// extracted by mini-css-extract-plugin
export var uploadFileBlockContent = "upload-file-block__content_IVzUg2imrlMhlrPK1SZJ";
export var uploadFileBlockDropzone = "upload-file-block__dropzone_YAywkXWVW2djeJKkqwVz";
export var uploadFileBlockDropzoneNonActive = "upload-file-block__dropzone_non-active_RTpdSEfnJcRGbA3Xujkt";
export var uploadFileBlockEmailCell = "upload-file-block__email-cell_aD90RGgf8XvaORbiLiv5";
export var uploadFileBlockHeader = "upload-file-block__header_MRQGg8h6GV8TQzUyC4Hi";
export var uploadFileBlockIdCell = "upload-file-block__id-cell_D9x70cg5dUCgLSiRyttB";
export var uploadFileBlockList = "upload-file-block__list_AAvmxDUZPG0tWnCMPHe6";
export var uploadFileBlockReviewPartition = "upload-file-block__review-partition_S1ku2RH0uq6enNIOXsSh";
export var uploadFileBlockUploadPartition = "upload-file-block__upload-partition_flSVQIt1upoQRPBlp48m";